import * as Rx from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import type IUserToken from 'v2/interfaces/tokens/userToken';

import tokenService from './token';
import type { TokenService } from './token';

class AuthService {
  private userToken$: Rx.Observable<IUserToken>;

  constructor(private tks: TokenService) {
    this.userToken$ = this.tks.getToken().pipe(
      map(token => {
        if (!token) {
          return null;
        }

        const userToken = this.tks.decode<IUserToken>(token);

        if (!userToken) {
          console.log('invalid token userToken');
          return null;
        }

        return userToken;
      }),
      catchError(() => {
        console.log('failed to observe user');
        return Rx.of(null);
      })
    );
  }

  public getUserToken(): Rx.Observable<IUserToken> {
    return this.userToken$;
  }

  public isAuthenticated(): Rx.Observable<boolean> {
    return this.getUserToken().pipe(map(user => !!user));
  }
}

const authService = new AuthService(tokenService);
export default authService;
